import { render, staticRenderFns } from "./lishi.vue?vue&type=template&id=6c2c886e"
import script from "./lishi.vue?vue&type=script&lang=js"
export * from "./lishi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports